export default "__VITE_ASSET__DfEWmRBz__ 500w";